import React from "react";
import "./AlertModal.css";

function AlertModal({ message, onClose }) {
  return (
    <div className="alert-modal-overlay">
      <div
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <p>{message}</p>
        <button className="btn btn-close" onClick={onClose}></button>
      </div>
    </div>
  );
}
export default AlertModal;
